export enum CookieConsent {
  Functional = 'functional-cookie-consent',
  Statistical = 'statistical-cookie-consent',
  ThirdParty = 'third-party-cookie-consent',
}
